// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-container {
  min-height: 300px;
}

table tr th:first-child {
  width: 70%;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/online-indicator/dialogs/connection-status-dialog/connection-status-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAIQ;EACI,UAAA;AADZ","sourcesContent":[".spinner-container {\n    min-height: 300px;\n}\n\ntable {\n    tr {\n        th:first-child {\n            width: 70%;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
